import { render, staticRenderFns } from "./EstatusEquipoDialogComponent.vue?vue&type=template&id=2b5f9b5a"
import script from "./EstatusEquipoDialogComponent.vue?vue&type=script&lang=js"
export * from "./EstatusEquipoDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports